// ALL ORG CONFIGURATION
export const configuration = {
  auth: {
    clientId: "f18e5f1e-493e-454e-b634-86c47325bb18",
    authority: "https://login.microsoftonline.com/organizations",
    redirectUri: window.location.origin,

  },
  // cache: {
  //   cacheLocation: "localStorage",
  // },
};

// EXDION CONFIGURATION
// export const configuration = {
//     auth: {
//         clientId: "4b7c74f3-48ed-4b82-abc6-8ec431258658",
//         authority:
//             "https://login.microsoftonline.com/ca7621e7-a15f-4dc1-9515-5cbd8ac365b8",
//         redirectUri: "https://lms.krtrimaiq.ai",
//     },
// cache: {
//   cacheLocation: "localStorage",
// },
// };
